import type { TabItem } from "components/UI/Tabs";
import type { ScheduleSortOrder } from "utils/type/schedule";

// 일정 목록 상태 탭 (강습 일정 / 연습반 일정 공통)
export const SCHEDULE_STATUS_TABS: TabItem[] = [
  { key: "all", label: "전체" },
  { key: "OPEN", label: "오픈" },
  { key: "CANCELLED", label: "취소" },
  // { key: "PENDING", label: "대기" },
  // { key: "APPROVED", label: "승인" },
  // { key: "REJECTED", label: "반려" },
];

// 일정 날짜 정렬 옵션
export const SCHEDULE_SORT_OPTIONS: { value: ScheduleSortOrder; label: string }[] = [
  { value: "latest", label: "최신순" },
  { value: "oldest", label: "오래된순" },
];
